import {BusinessLineDto, DocumentVersionDto, UserDto} from '../services/generated';
import {DocumentSystem} from './DocumentSystem';

export class DocumentVersion extends DocumentSystem implements DocumentVersionDto {
  public relativeUrl: string | null;
  public created: string | null;
  public createdBy: UserDto | null;
  public modified: string | null;
  public modifiedBy: UserDto | null;
  public nextConfirmationDate: string | null;
  public businessLines: BusinessLineDto[] | null;
  public keyWords: string[] | null;
  public isFavorite: boolean | null;

  constructor(document: DocumentVersionDto) {
    super(document);
    this.relativeUrl = document.relativeUrl;
    this.created = document.created;
    this.createdBy = document.createdBy;
    this.nextConfirmationDate = document.nextConfirmationDate;
    this.modified = document.modified;
    this.modifiedBy = document.modifiedBy;
    this.businessLines = document.businessLines;
    this.keyWords = document.keyWords;
    this.isFavorite = document.isFavorite;
}
}